/* eslint-disable @typescript-eslint/indent */
/* eslint-disable multiline-ternary */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React, { useRef, FC } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTextTranslation } from '../../contexts/TextTranslation'
import { useOnClickOutside } from '../../services/hooks/on-click-outside'
import { BASE_URL_CDN } from '../../utils/const'
import { TRest } from '../../utils/typesFromBackend'
import ButtonId from '../button-id/button-id'
import Hamburger from '../hamburger/hamburger'
import SocialNetworks from '../social-networks/socialNetworks'
import style from './hamburger-menu.module.css'
import {
  correctPositionWhenCloseModal,
  correctPositionWhenOnModal
} from '../../utils/utils'
import LanguageSelect from '../language-select/language-select'
import { useSelector } from 'react-redux'
import { RootState } from '../../services/store'
import useLinkWithParams from '../../services/hooks/useLinkWithParams'
import ChangeRestButton from '../change-rest-button/change-rest-button'
import { stringIsNotEmpty } from '../../helpers/stingIsNotEmpty'

interface IHamburgerMenu {
  rest: TRest
  setIsScrollButtonVisible: (arg: boolean) => void
}
const HamburgerMenu: FC<IHamburgerMenu> = ({
  rest,
  setIsScrollButtonVisible
}) => {
  const search = useLocation().search
  const numberTable = new URLSearchParams(search).get('numberTable')
  const [open, setOpen] = React.useState<boolean>(false)
  const [showOrderLink, setShowOrderLink] = React.useState(false)
  const translation = useTextTranslation()
  const person = useSelector((store: RootState) => store.user)

  const createLink = useLinkWithParams()
  // функция для создания ссылки на страницу пользователя в зависимости от того, авторизован ли он
  const getPersonLink = (): string => {
    if (person.isLoggedIn) {
      return createLink('/person')
    } else {
      return createLink('/person-sign-in')
    }
  }

  React.useEffect(() => {
    if (open) {
      correctPositionWhenOnModal()
      document.body.style.overflow = 'hidden'
      setIsScrollButtonVisible(false)
    } else {
      correctPositionWhenCloseModal()
      document.body.style.overflow = 'unset'
      setIsScrollButtonVisible(true)
    }
  }, [open])

  React.useEffect(() => {
    if (rest.tariff === 'Basic' || rest.tariff === 'Extend') {
      setShowOrderLink(false)
    } else {
      setShowOrderLink(true)
    }
  }, [rest.tariff])

  const close = (): void => setOpen(false)

  const node = useRef<HTMLDivElement>(null)
  useOnClickOutside(node, () => setOpen(false))

  const styleBackgroundColor = {
    background: rest.colorsSchema_id.leftMenuBgColor
  }
  const styleMainTextColor = {
    color: rest.colorsSchema_id.mainTextColor
  }

  return (
    <>
      <div className={style.menu} ref={node}>
        <nav
          className={open ? `${style.open}` : `${style.close}`}
          style={styleBackgroundColor}
        >
          <div
            className={style['slide-menu__body']}
            style={styleBackgroundColor}
          >
            <div className={style['slide-menu__top']}>
              {rest.logoPath.length > 0 ? (
                <div className={style['slide-menu__logo']}>
                  <img
                    src={`${BASE_URL_CDN}${'/'}${rest.logoPath}`}
                    className={style['slide-menu__logo_border']}
                    alt='Логотип'
                  />
                </div>
              ) : (
                ''
              )}
              <div className={style['slide-menu__logo']}>

                <ChangeRestButton
                  rest={rest}
                  buttonTitle={rest.titleRest}
                  styleMainTextColor={styleMainTextColor}
                />
                {/* персонально для мама миа, слишком им надо */}
                {rest.pathRest !== 'mama-mia' ? (
                  <span className={style.addressText} style={styleMainTextColor}>
                    {[
                      stringIsNotEmpty(rest.location_detail?.city)
                        ? rest.location_detail.city
                        : '',
                      stringIsNotEmpty(rest.location_detail?.street)
                        ? rest.location_detail.street
                        : '',
                      stringIsNotEmpty(rest.location_detail?.building)
                        ? `дом ${rest.location_detail.building}`
                        : '',
                      stringIsNotEmpty(rest.location_detail?.porch)
                        ? `подъезд ${rest.location_detail.porch}`
                        : '',
                      stringIsNotEmpty(rest.location_detail?.sfloor)
                        ? `этаж ${rest.location_detail.sfloor}`
                        : ''
                    ]
                      .filter((value) => value.trim().length > 0)
                      .join(', ')}
                  </span>) : (<span></span>)
                }
              </div>
              <ul className={style['slide-menu__ul']}>
                <li className={style['slide-menu__li']}>
                  <svg
                    width='22'
                    height='22'
                    viewBox='0 0 16 17'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M16 7.78097V15.6399C16 16.0006 15.8595 16.3466 15.6095 16.6016C15.3594 16.8567 15.0203 17 14.6666 17H11.3333C10.9797 17 10.6406 16.8567 10.3905 16.6016C10.1405 16.3466 9.99999 16.0006 9.99999 15.6399V12.2396C9.99999 12.0592 9.92975 11.8863 9.80473 11.7587C9.6797 11.6312 9.51013 11.5595 9.33332 11.5595H6.66666C6.48985 11.5595 6.32028 11.6312 6.19525 11.7587C6.07023 11.8863 5.99999 12.0592 5.99999 12.2396V15.6399C5.99999 16.0006 5.85952 16.3466 5.60947 16.6016C5.35942 16.8567 5.02028 17 4.66666 17H1.33333C0.97971 17 0.640572 16.8567 0.390524 16.6016C0.140476 16.3466 1.54065e-08 16.0006 1.54065e-08 15.6399V7.78097C-2.80357e-05 7.59273 0.0382493 7.40653 0.112409 7.23416C0.18657 7.06179 0.294998 6.907 0.430833 6.77958L7.09749 0.363235L7.10666 0.353884C7.35211 0.126178 7.67197 0 8.00374 0C8.33552 0 8.65537 0.126178 8.90082 0.353884C8.90367 0.357211 8.90673 0.360335 8.90999 0.363235L15.5766 6.77958C15.7111 6.90767 15.8182 7.06276 15.891 7.2351C15.9639 7.40744 16.001 7.59329 16 7.78097Z'
                      fill={rest.colorsSchema_id.colorIcon}
                    />
                  </svg>

                  <Link
                    onClick={() => close()}
                    to={createLink('')}
                    className={style['slide-menu__a']}
                    style={styleMainTextColor}
                  >
                    {translation('main')}
                  </Link>
                </li>
                <hr
                  style={{ border: `1px solid ${rest.colorsSchema_id.stroke}` }}
                  className={style.line}
                />
                {showOrderLink ? (
                  <li className={style['slide-menu__li']}>
                    <svg
                      width='22'
                      height='22'
                      viewBox='0 0 18 18'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M17.843 3.57213C17.7804 3.49725 17.7022 3.43702 17.6138 3.3957C17.5254 3.35438 17.429 3.33297 17.3314 3.33299H3.88957L3.48211 1.09489C3.42631 0.787697 3.26445 0.509839 3.02478 0.309753C2.7851 0.109666 2.48281 4.5124e-05 2.17059 0H0.666593C0.489801 0 0.320251 0.0702305 0.19524 0.195242C0.0702301 0.320253 0 0.489805 0 0.666597C0 0.84339 0.0702301 1.01294 0.19524 1.13795C0.320251 1.26296 0.489801 1.33319 0.666593 1.33319H2.16643L4.29619 13.0228C4.35893 13.3695 4.51213 13.6934 4.74031 13.9619C4.42538 14.256 4.19808 14.6317 4.08359 15.0471C3.96911 15.4626 3.97193 15.9016 4.09174 16.3155C4.21154 16.7295 4.44365 17.1022 4.76233 17.3922C5.081 17.6823 5.47379 17.8785 5.89714 17.959C6.32049 18.0394 6.75786 18.0011 7.16075 17.8482C7.56363 17.6952 7.91629 17.4337 8.17963 17.0926C8.44296 16.7515 8.60667 16.3441 8.65261 15.9156C8.69855 15.4872 8.62493 15.0543 8.4399 14.6651H12.2245C12.0753 14.9773 11.9982 15.319 11.9987 15.665C11.9987 16.1265 12.1355 16.5776 12.3919 16.9612C12.6482 17.3449 13.0126 17.6439 13.4389 17.8205C13.8652 17.9971 14.3343 18.0433 14.7869 17.9533C15.2395 17.8633 15.6552 17.6411 15.9815 17.3148C16.3078 16.9885 16.53 16.5728 16.62 16.1202C16.71 15.6676 16.6638 15.1985 16.4872 14.7722C16.3106 14.3459 16.0116 13.9815 15.6279 13.7251C15.2443 13.4688 14.7932 13.3319 14.3317 13.3319H6.26347C6.10736 13.3319 5.95622 13.2771 5.83638 13.1771C5.71654 13.077 5.63562 12.9381 5.60771 12.7845L5.34357 11.3322H15.0092C15.4775 11.3321 15.9309 11.1677 16.2904 10.8675C16.65 10.5674 16.8927 10.1506 16.9764 9.68982L17.9897 4.11874C18.0068 4.02245 18.0026 3.92356 17.9772 3.8291C17.9519 3.73463 17.9061 3.6469 17.843 3.57213ZM7.33252 15.665C7.33252 15.8628 7.27388 16.0561 7.16401 16.2205C7.05414 16.385 6.89798 16.5131 6.71527 16.5888C6.53257 16.6645 6.33152 16.6843 6.13756 16.6457C5.9436 16.6071 5.76544 16.5119 5.6256 16.3721C5.48576 16.2322 5.39053 16.0541 5.35195 15.8601C5.31337 15.6661 5.33317 15.4651 5.40885 15.2824C5.48453 15.0997 5.61269 14.9435 5.77712 14.8337C5.94155 14.7238 6.13487 14.6651 6.33263 14.6651C6.59782 14.6651 6.85214 14.7705 7.03966 14.958C7.22717 15.1455 7.33252 15.3998 7.33252 15.665ZM15.3316 15.665C15.3316 15.8628 15.273 16.0561 15.1631 16.2205C15.0533 16.385 14.8971 16.5131 14.7144 16.5888C14.5317 16.6645 14.3306 16.6843 14.1367 16.6457C13.9427 16.6071 13.7646 16.5119 13.6247 16.3721C13.4849 16.2322 13.3896 16.0541 13.3511 15.8601C13.3125 15.6661 13.3323 15.4651 13.408 15.2824C13.4836 15.0997 13.6118 14.9435 13.7762 14.8337C13.9407 14.7238 14.134 14.6651 14.3317 14.6651C14.5969 14.6651 14.8513 14.7705 15.0388 14.958C15.2263 15.1455 15.3316 15.3998 15.3316 15.665ZM15.6649 9.45151C15.6369 9.60553 15.5557 9.74479 15.4353 9.84488C15.3149 9.94498 15.1632 9.99952 15.0067 9.99896H5.1011L4.13204 4.66618H16.5323L15.6649 9.45151Z'
                        fill={rest.colorsSchema_id.colorIcon}
                      />
                    </svg>
                    <Link
                      onClick={() => close()}
                      to={createLink('/orders')}
                      className={style['slide-menu__a']}
                      style={styleMainTextColor}
                    >
                      {translation('orders')}
                    </Link>
                  </li>
                ) : (
                  ''
                )}
                {showOrderLink ? (
                  <hr
                    style={{
                      border: `1px solid ${rest.colorsSchema_id.stroke}`
                    }}
                    className={style.line}
                  />
                ) : (
                  ''
                )}
                <li className={style['slide-menu__li']}>
                  <svg
                    width='22'
                    height='22'
                    viewBox='0 0 22 22'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M11 0C8.82441 0 6.69767 0.645139 4.88873 1.85383C3.07979 3.06253 1.66989 4.78049 0.83733 6.79048C0.00476613 8.80047 -0.213071 11.0122 0.211367 13.146C0.635804 15.2798 1.68345 17.2398 3.22183 18.7782C4.76021 20.3165 6.72022 21.3642 8.85401 21.7886C10.9878 22.2131 13.1995 21.9952 15.2095 21.1627C17.2195 20.3301 18.9375 18.9202 20.1462 17.1113C21.3549 15.3023 22 13.1756 22 11C21.9969 8.08356 20.837 5.28746 18.7748 3.22523C16.7125 1.16299 13.9164 0.00307981 11 0ZM5.29693 18.351C5.90905 17.3936 6.75232 16.6058 7.749 16.0601C8.74568 15.5143 9.8637 15.2283 11 15.2283C12.1363 15.2283 13.2543 15.5143 14.251 16.0601C15.2477 16.6058 16.091 17.3936 16.7031 18.351C15.0725 19.6191 13.0657 20.3076 11 20.3076C8.93431 20.3076 6.92753 19.6191 5.29693 18.351ZM7.61539 10.1538C7.61539 9.48443 7.81389 8.83005 8.1858 8.27345C8.5577 7.71686 9.08631 7.28304 9.70477 7.02687C10.3232 6.77069 11.0038 6.70367 11.6603 6.83426C12.3169 6.96486 12.9199 7.28721 13.3933 7.76056C13.8666 8.23391 14.189 8.83699 14.3196 9.49354C14.4502 10.1501 14.3832 10.8306 14.127 11.4491C13.8708 12.0675 13.437 12.5961 12.8804 12.968C12.3238 13.34 11.6694 13.5385 11 13.5385C10.1023 13.5385 9.24146 13.1819 8.60672 12.5471C7.97198 11.9124 7.61539 11.0515 7.61539 10.1538ZM17.9554 17.178C17.0117 15.8105 15.6847 14.7525 14.1413 14.1371C14.9704 13.4841 15.5753 12.5891 15.8721 11.5763C16.1688 10.5636 16.1426 9.48358 15.7971 8.48644C15.4515 7.48931 14.8039 6.62463 13.9441 6.01265C13.0844 5.40068 12.0553 5.07182 11 5.07182C9.9447 5.07182 8.91562 5.40068 8.05588 6.01265C7.19613 6.62463 6.54846 7.48931 6.20293 8.48644C5.8574 9.48358 5.83118 10.5636 6.12793 11.5763C6.42467 12.5891 7.02962 13.4841 7.85866 14.1371C6.31529 14.7525 4.98833 15.8105 4.04462 17.178C2.85214 15.837 2.07273 14.1799 1.80024 12.4062C1.52775 10.6325 1.7738 8.81787 2.50876 7.18078C3.24372 5.54369 4.43625 4.15396 5.94276 3.17893C7.44926 2.20391 9.2055 1.68516 11 1.68516C12.7945 1.68516 14.5507 2.20391 16.0572 3.17893C17.5638 4.15396 18.7563 5.54369 19.4912 7.18078C20.2262 8.81787 20.4722 10.6325 20.1998 12.4062C19.9273 14.1799 19.1479 15.837 17.9554 17.178Z'
                      fill={rest.colorsSchema_id.colorIcon}
                    />
                  </svg>
                  <Link
                    onClick={() => close()}
                    to={getPersonLink()}
                    className={style['slide-menu__a']}
                    style={styleMainTextColor}
                  >
                    {translation('profile')}
                  </Link>
                </li>
                <hr
                  style={{ border: `1px solid ${rest.colorsSchema_id.stroke}` }}
                  className={style.line}
                />
                {rest.enableTips ? (
                  rest.tipsLayoutID.length > 0 ? (
                    <li className={style['slide-menu__li']}>
                      <svg
                        width='22'
                        height='22'
                        viewBox='0 0 19 19'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M18.9481 4.58816C18.8806 4.37761 18.7521 4.19184 18.5788 4.05442C18.4056 3.917 18.1955 3.83411 17.9751 3.81627L14.8179 3.54908L13.5862 0.67781C13.4993 0.476518 13.3553 0.305076 13.1721 0.184629C12.9889 0.064182 12.7744 0 12.5551 0C12.3359 0 12.1214 0.064182 11.9382 0.184629C11.7549 0.305076 11.611 0.476518 11.5241 0.67781L10.2924 3.54992L7.13428 3.81627C6.91499 3.83388 6.70583 3.91604 6.53318 4.05238C6.36053 4.18872 6.23212 4.37314 6.16416 4.58237C6.0962 4.7916 6.09173 5.01627 6.15131 5.22804C6.21089 5.4398 6.33185 5.62919 6.49893 5.77229L8.88765 7.80805L8.17256 10.8388C8.12228 11.0512 8.1357 11.2738 8.21113 11.4786C8.28656 11.6835 8.42066 11.8616 8.59669 11.9907C8.7748 12.1215 8.98752 12.1969 9.20825 12.2074C9.42898 12.218 9.64792 12.1632 9.8377 12.0501L12.5522 10.4384L15.2666 12.0501C15.4564 12.1632 15.6753 12.218 15.8961 12.2074C16.1168 12.1969 16.3295 12.1215 16.5076 11.9907C16.6837 11.8616 16.8179 11.6835 16.8933 11.4787C16.9688 11.2738 16.9821 11.0512 16.9317 10.8388L16.2167 7.80805L18.6045 5.77229C18.7726 5.63109 18.8949 5.44319 18.9561 5.23239C19.0173 5.02158 19.0145 4.79737 18.9481 4.58816ZM15.2276 6.87839C15.0713 7.01081 14.9548 7.18397 14.891 7.37864C14.8272 7.57331 14.8186 7.78185 14.8662 7.98109L15.4863 10.6106L13.1298 9.21018C12.9559 9.10649 12.7572 9.05175 12.5547 9.05175C12.3522 9.05175 12.1535 9.10649 11.9796 9.21018L9.62309 10.6021L10.2432 7.97261C10.2915 7.77346 10.2833 7.56479 10.2197 7.37001C10.156 7.17524 10.0393 7.00206 9.88266 6.8699L7.82477 5.12085L10.5469 4.89013C10.7489 4.87318 10.9425 4.80153 11.1069 4.68288C11.2713 4.56422 11.4002 4.40304 11.4799 4.21663L12.5547 1.71605L13.6269 4.21663C13.7068 4.40293 13.8358 4.56402 14.0001 4.68265C14.1645 4.80128 14.358 4.873 14.56 4.89013L17.2821 5.12085L15.2276 6.87839ZM5.90939 9.30094L1.15911 14.051C1.03177 14.1784 0.859068 14.2499 0.678989 14.2499C0.49891 14.2499 0.326207 14.1784 0.198871 14.051C0.0715362 13.9237 0 13.751 0 13.5709C0 13.3909 0.0715362 13.2182 0.198871 13.0908L4.94915 8.34074C5.07649 8.21341 5.24919 8.14187 5.42927 8.14187C5.60935 8.14187 5.78205 8.21341 5.90939 8.34074C6.03673 8.46807 6.10826 8.64077 6.10826 8.82084C6.10826 9.00091 6.03673 9.17361 5.90939 9.30094ZM7.26661 14.051L2.51633 18.8011C2.45328 18.8642 2.37843 18.9142 2.29605 18.9483C2.21367 18.9824 2.12538 19 2.03621 19C1.94705 19 1.85875 18.9824 1.77637 18.9483C1.694 18.9142 1.61914 18.8642 1.55609 18.8011C1.49304 18.7381 1.44303 18.6632 1.40891 18.5809C1.37479 18.4985 1.35722 18.4102 1.35722 18.321C1.35722 18.2319 1.37479 18.1436 1.40891 18.0612C1.44303 17.9788 1.49304 17.904 1.55609 17.8409L6.30638 13.0908C6.43371 12.9635 6.60642 12.892 6.7865 12.892C6.96657 12.892 7.13928 12.9635 7.26661 13.0908C7.39395 13.2182 7.46548 13.3909 7.46548 13.5709C7.46548 13.751 7.39395 13.9237 7.26661 14.051ZM13.3741 13.0908C13.4372 13.1539 13.4873 13.2287 13.5214 13.3111C13.5556 13.3935 13.5731 13.4818 13.5731 13.5709C13.5731 13.6601 13.5556 13.7484 13.5214 13.8308C13.4873 13.9132 13.4372 13.988 13.3741 14.051L8.62384 18.8011C8.56079 18.8642 8.48594 18.9142 8.40356 18.9483C8.32118 18.9824 8.23289 19 8.14372 19C8.05455 19 7.96626 18.9824 7.88388 18.9483C7.8015 18.9142 7.72665 18.8642 7.6636 18.8011C7.60055 18.7381 7.55054 18.6632 7.51641 18.5809C7.48229 18.4985 7.46473 18.4102 7.46473 18.321C7.46473 18.2319 7.48229 18.1436 7.51641 18.0612C7.55054 17.9788 7.60055 17.904 7.6636 17.8409L12.4139 13.0908C12.4769 13.0277 12.5518 12.9777 12.6341 12.9435C12.7165 12.9094 12.8048 12.8918 12.894 12.8918C12.9832 12.8918 13.0715 12.9094 13.1539 12.9435C13.2363 12.9777 13.3111 13.0277 13.3741 13.0908Z'
                          fill={rest.colorsSchema_id.colorIcon}
                        />
                      </svg>

                      <a
                        onClick={() => close()}
                        href={`https://netmonet.co/tip/${rest.tipsLayoutID}?o=6`}
                        className={style['slide-menu__a']}
                        target='_blank'
                        rel='noreferrer'
                        style={styleMainTextColor}
                      >
                        {translation('write-review')}
                      </a>
                    </li>
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
                {rest.enableTips ? (
                  <hr
                    style={{
                      border: `1px solid ${rest.colorsSchema_id.stroke}`
                    }}
                    className={style.line}
                  />
                ) : (
                  ''
                )}
                <li className={style['slide-menu__li']}>
                  <svg
                    width='22'
                    height='22'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9972 7.34869 18.9427 4.80678 17.068 2.93202C15.1932 1.05727 12.6513 0.00279983 10 0ZM10 18.4615C8.32647 18.4615 6.69052 17.9653 5.29902 17.0355C3.90753 16.1057 2.823 14.7842 2.18256 13.2381C1.54213 11.6919 1.37456 9.99061 1.70105 8.34923C2.02754 6.70786 2.83343 5.20016 4.01679 4.01679C5.20016 2.83342 6.70786 2.02754 8.34924 1.70105C9.99062 1.37456 11.6919 1.54212 13.2381 2.18256C14.7842 2.82299 16.1057 3.90753 17.0355 5.29902C17.9653 6.69051 18.4615 8.32646 18.4615 10C18.459 12.2434 17.5667 14.3941 15.9804 15.9804C14.3941 17.5667 12.2434 18.459 10 18.4615ZM11.5385 14.6154C11.5385 14.8194 11.4574 15.0151 11.3132 15.1593C11.1689 15.3036 10.9732 15.3846 10.7692 15.3846C10.3612 15.3846 9.96989 15.2225 9.68138 14.934C9.39286 14.6455 9.23077 14.2542 9.23077 13.8462V10C9.02676 10 8.8311 9.91895 8.68684 9.7747C8.54259 9.63044 8.46154 9.43478 8.46154 9.23077C8.46154 9.02675 8.54259 8.8311 8.68684 8.68684C8.8311 8.54258 9.02676 8.46154 9.23077 8.46154C9.6388 8.46154 10.0301 8.62362 10.3186 8.91214C10.6071 9.20066 10.7692 9.59197 10.7692 10V13.8462C10.9732 13.8462 11.1689 13.9272 11.3132 14.0715C11.4574 14.2157 11.5385 14.4114 11.5385 14.6154ZM8.46154 5.76923C8.46154 5.54102 8.52921 5.31794 8.656 5.12819C8.78279 4.93844 8.96299 4.79055 9.17383 4.70321C9.38467 4.61588 9.61667 4.59303 9.84049 4.63755C10.0643 4.68208 10.2699 4.79197 10.4313 4.95334C10.5926 5.11471 10.7025 5.3203 10.7471 5.54413C10.7916 5.76795 10.7687 5.99995 10.6814 6.21079C10.5941 6.42163 10.4462 6.60183 10.2564 6.72862C10.0667 6.8554 9.8436 6.92308 9.61539 6.92308C9.30937 6.92308 9.01588 6.80151 8.79949 6.58512C8.58311 6.36873 8.46154 6.07525 8.46154 5.76923Z'
                      fill={rest.colorsSchema_id.colorIcon}
                    />
                  </svg>

                  <Link
                    onClick={() => close()}
                    to={createLink('/about-us')}
                    className={style['slide-menu__a']}
                    style={styleMainTextColor}
                  >
                    {translation('about-us')}
                  </Link>
                </li>
                <hr
                  style={{ border: `1px solid ${rest.colorsSchema_id.stroke}` }}
                  className={style.line}
                />
              </ul>
              <div className={style['slide-menu__LanguageSelect']}>
                <LanguageSelect rest={rest} />
              </div>
            </div>
            {numberTable
              ? rest.buttons_ids.map((button) => {
                return (
                  button.active && (
                    <div style={{ marginTop: '30px' }} key={button._id}>
                      <ButtonId
                        rest_id={rest._id}
                        numberTable={numberTable}
                        button={button}
                        open={open}
                        setOpen={setOpen}
                        buttonTextColor={rest.colorsSchema_id.buttonTextColor}
                        buttonColor={rest.colorsSchema_id.buttonColor}
                      />
                    </div>
                  )
                )
              })
              : ''}
            <div style={{ marginBottom: '30%', marginTop: '20px' }}>
              <SocialNetworks rest={rest} />
              <hr
                style={{ border: `1px solid ${rest.colorsSchema_id.stroke}` }}
                className={style.line}
              />
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <svg
                  style={{ cursor: 'pointer', paddingBottom: '50px' }}
                  onClick={() => setOpen(!open)}
                  width='33'
                  height='34'
                  viewBox='0 0 33 34'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M16.4999 31.1668C10.9361 31.17 5.91861 27.7184 3.78897 22.4225C1.65933 17.1266 2.8373 11.0303 6.77318 6.97851C10.2482 3.39818 15.3132 1.99989 20.0602 3.31039C24.8071 4.62088 28.515 8.44106 29.7869 13.3319C31.0589 18.2227 29.7017 23.4412 26.2267 27.0215C23.6519 29.6863 20.1494 31.1789 16.4999 31.1668ZM5.49993 17.2437C5.56499 23.4788 10.5064 28.4885 16.5584 28.4552C22.6104 28.4215 27.4993 23.3573 27.4993 17.1218C27.4993 10.8864 22.6104 5.82219 16.5584 5.78851C10.5064 5.75516 5.56499 10.7649 5.49993 17V17.2437ZM12.9373 22.6667L10.9999 20.6692L14.5612 17L10.9999 13.3308L12.9387 11.3333L16.4999 15.0025L20.0612 11.3333L21.9999 13.3308L18.4387 17L21.9999 20.6692L20.0626 22.6667L16.4999 18.9975L12.9387 22.6667H12.9373Z'
                    fill={rest.colorsSchema_id.mainColor}
                  />
                </svg>
              </div>
            </div>
          </div>
        </nav>
        <div style={{ zIndex: 0 }}>
          <Hamburger
            open={open}
            setOpen={setOpen}
            backgroundColor={rest.colorsSchema_id.mainColor}
          />
        </div>
      </div>
      <div className={open ? `${style.background}` : `${style.close}`}></div>
    </>
  )
}

export default HamburgerMenu
